import React, { useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, GpsBaseURL, uniqueToken, Role } from '../../api/DataApis';
import { LuUser2 } from 'react-icons/lu';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';



  const ImportExcel = () => {
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [Users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [SelectedState, setSelectedState] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedCorporate, setSelectedCorporate] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [file, setFile] = useState(null); // State to hold the selected file
  const [isLoading, setIsLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [error, setError] = useState(null);
  const [UserID, setUserID] =  useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [Loaders, setLoaders] =  useState(false);
  
  const [CorporateData, setCorporateData] =  useState([]);
  const [confirmation, setconfirmation] =  ("1");
  const [previewData, setPreviewData] = useState(null);



 


  console.log("Roleeeeeee", Role);
  console.log("selectedCorporate", selectedCorporate);

// console.log("role", Role);
const fetchCorporate = async (page) => {
  //setLoadings(true);
  
  // Base API URL
  let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
 try {
    const response = await axios.get(apiEndpoint, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
      },
    });

    console.log("response", response);
   
    setCorporateData(response.data?.data);
   
// Assuming API returns totalCount for pagination
  } catch (error) {
    console.error("Error fetching users:", error);
  } finally {
    //setLoadings(false);
  }
};

// Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporate();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);
console.log("UserID", UserID);
  const fileInputRef = useRef(null);
  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    console.log("hellllo-909");
    setFile(selectedFile); // Store the file in state
  
    if (selectedFile) {
    
      // Preview Excel file
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
    
        // Assuming you want to read the first sheet
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
        console.log("jsonData", jsonData);
    
        // Open the SweetAlert2 modal for confirmation
        const confirmation = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to upload this file?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          html: `        
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">
  ${Role === "false" ? 
    `<select id="selectBox" class="swal2-input form-control" style="margin-top: 10px; width: 100%; max-width: 300px;">
      <option value="">Select Corporate</option>
      ${CorporateData.map(option => 
        `<option value="${option._id}">${option.name}</option>`
      ).join('')}
    </select>` 
  : ''}

  <textarea id="inputBox" class="swal2-input form-control" placeholder="Enter Your Comment" rows="6" cols="50" style="width: 100%; max-width: 300px; height: 100px; margin-top: 10px;"></textarea>

  <!-- Preview table will be placed here -->
  ${jsonData && jsonData[0] ? `<h4>Preview:</h4>` : ''}
  <table border="1" style="width: 100%; margin-top: 15px; font-size: 10px; text-align: left;">
    <thead>
      <tr>
        ${jsonData && jsonData[0] ? jsonData[0].slice(0, 4).map(col => `<th>${col.charAt(0).toUpperCase() + col.slice(1)}</th>`).join('') : ''}
      </tr>
    </thead>
    <tbody>
      ${jsonData && jsonData.slice(1).map(row => `
        <tr>
          ${row.slice(0, 3).map(cell => `<td>${cell}</td>`).join('')}
          <td>
            ${row[3]?.slice(0, 3)}... <!-- Show the first 3 characters with ellipsis -->
          </td>
        </tr>
      `).join('')}
    </tbody>
  </table>
</div>

          `,
          didOpen: () => {
            // Move the buttons to the end of the modal
            const confirmButton = Swal.getConfirmButton();
            const cancelButton = Swal.getCancelButton();
            confirmButton.style.marginTop = '15px';
            cancelButton.style.marginTop = '15px';
          },
          preConfirm: () => {
            const inputText = document.getElementById('inputBox')?.value;
            const selectedOption = document.getElementById('selectBox')?.value;
          
            if (!selectedOption && Role ==="false") {
              Swal.showValidationMessage("Please Select Corporate");
              return false; // Prevent modal from closing
            }
            if (!inputText) {
              Swal.showValidationMessage("Please Enter Comment");
              return false; // Prevent modal from closing
            }
          
            return { inputText, selectedOption };
          }
          
        });
  
        if (confirmation.isConfirmed) {
          setIsLoading(true);
          const { inputText, selectedOption } = confirmation?.value;
  
          // Append the data to FormData before sending the request
          const formData = new FormData();
          formData.append('file', selectedFile); // Append the selected file
          if (selectedOption) formData.append('corporate_id', selectedOption);
          formData.append('comment', inputText);
  
          try {
            const response = await fetch(`${GpsBaseURL}/excel/import-excel`, {
              method: 'POST',
              body: formData,
              headers: {
                Authorization: `Bearer ${uniqueToken}`,
                // 'Content-Type' is automatically set when using FormData
              },
            });
  
            const data = await response.json();
            setIsLoading(false);
  
            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: data.message,
                showConfirmButton: false,
                timer: 1000,
              });
              fetchUsers(page);
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: data.message,
              });
              setFile(null); // Reset the file state after failure
            }
          } catch (error) {
            setIsLoading(false);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'An unexpected error occurred during file upload.',
            });
            setFile(null); // Reset the file state after failure
            return false;
          }
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Cancelled',
            text: 'Your file upload has been cancelled.',
            showConfirmButton: false,
            timer: 1500,
          });
          setFile(null);
          return false;
        }
      };
      reader.readAsBinaryString(selectedFile);
    }
  
    // Reset the file input value here
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the input value
    }
  };
  
  
  
  
 

  let navigate = useNavigate();


  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/importExcel`);
    }
 document.title = "Import Excel";


  
const handleselectedStatusType = (e) => {
  setselectedStatusType(e.target.value);
}
const corporateOptions = CorporateData.map(corporate => ({
  value: corporate._id,
  label: `${corporate.name} (${corporate?.email})`,
  _id: corporate._id,
}));

const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption3wrewgfreh", selectedOption);
 setSelectedCorporate({ id: selectedOption._id });
}


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
 const fetchUsers = async (page) => {
    setLoadings(true);
    setHasFetched(false); // 
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/excel?page=${page}`);
   
    const queryParams = [];
  if (searchQuery) queryParams.push(`&searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`&status=${selectStatusType}`);
    if (selectedCorporate?.id) queryParams.push(`&corporate_id=${selectedCorporate?.id}`);
    //
    
    
    const apiUrl = `${apiEndpoint}${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
      setUsers(response.data.data || []);
       setFilteredData(response?.data?.data?.data);
      setTotalCount(response?.data?.data?.count || 0);
      setLimit(response?.data?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
      setHasFetched(true); // Mark that API has completed fetching
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm,  page, confirmation]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

   const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/excel?page=${page}`;
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedStatusType) {
    params.push(`status=${selectStatusType}`);
}
if (selectedCorporate?.id)
  params.push(`corporate_id=${selectedCorporate?.id}`);



  // Add selected country, state, and city to the params


  // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const response = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (response && response?.data) {
        setUsers(response.data.data || []);
        setFilteredData(response?.data?.data?.data);
       setTotalCount(response?.data?.data?.count || 0);
       setLimit(response?.data?.data?.limit);
       setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};


const handleButtonClick = (e) => {
  e.preventDefault();
  fileInputRef.current.click(); // Trigger the hidden file input click
};
const handleDownloadDemofile = (e) => {
  e.preventDefault();
  const link = document.createElement("a");
  link.href = "/demo_file_download.xlsx"; // Relative path from the public folder
  link.download = "demo-file.xlsx"; // Set the downloaded file name
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

 console.log("users", Users);
  console.log("totalCount", totalCount);
  console.log("pagecount", pageCount);
  console.log("limit", Limit);
  console.log("filtredData", filteredData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Import File({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>


</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap", // Allows wrapping on smaller screens
      }}
    >
   
    
    </div>

    {/* New line for next set of fields */}
    <div
      className="row px-3"
      style={{
        display: "flex",
        flexWrap: "wrap", // Allow wrapping on smaller screens
        marginTop: "10px", // Space between groups
      }}
    >
      <div className="col-md-2 col-sm-12">
        <div className="form-group">
          <select
            value={selectStatusType}
            onChange={handleselectedStatusType}
            className="form-control select2 select2-offscreen"
            style={{
              height: "38px",
              width: "100%",
            }}
          >
            <option value="">Select Status</option>
            <option value="Pending">Pending</option>
            <option value="Processing">Processing</option>
            <option value="Completed">Completed</option>
          </select>
        </div>
      </div>
      {Role === "false" && (
<div className="col-md-2 col-sm-12"style={{alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={corporateOptions}
      onChange={handlecorporateChange}
      value={corporateOptions?.find(option => option.value === selectedCorporate.id) || null}
      placeholder="Select Corporate"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
  </div>
</div>
)}

      <div className="col-md-2 col-sm-12">
        <div className="form-group">
          <input
            placeholder="Find Data Here"
            className="form-control"
            style={{
              borderRadius: "8px",
              padding: "6px 10px",
              marginRight: "10px",
              height: "38px",
            }}
            value={searchQuery}
            onChange={handleSearchTextChange}
          />
        </div>
      </div>


      <div
        className="col-md-2 col-sm-12"
        style={{ display: "flex", alignItems: "center" }}
      >
        <button
          className="btn btn-primary"
          onClick={handleSearchSubmit}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Search
        </button>

        <button
          className="btn btn-primary"
          onClick={handleReset}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Reset
        </button>
        <button
          className="btn btn-primary"
          onClick={handleDownloadDemofile}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "140px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Download
        </button>
        <div className="col-md-2 col-sm-12">
        <div className="form-group">
          <button
            className="drop-marg12 btn alignright"
            style={{
              border: "1px solid black",
              borderRadius: "15px",
              background: "white",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 10px",
            }}
            onClick={handleButtonClick}
          >
            {isLoading ? (
    <div className="spinner" style={{ marginRight: '10px' }}></div> // You can style it as needed
  ) : (
    "Import" // Button text is shown when not loading
  )}
          </button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }} // Hide the actual file input
            onChange={handleFileChange}
          />
        </div>
      </div>
      
      </div>
    </div>
  </form>
</div>




<div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader />
  ) : hasFetched && totalCount === 0 ? (
    <div className="text-center">
      <h5>No File Data Found</h5>
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>


    <th style={{ minWidth: '80px' }}>Sr No</th>
    <th style={{ minWidth: '200px' }}>File Name</th>
    {Role ==="false" && (
    <th style={{ minWidth: '200px' }}>Corporate Name</th>
  )}

    <th style={{ minWidth: '100px' }}>Total Users</th>
    <th style={{ minWidth: '100px' }}>Success</th>
    <th style={{ minWidth: '100px' }}>Failures</th>
    <th style={{ minWidth: '100px' }}>Status</th>

    <th style={{ minWidth: '150px' }}>Uploaded By</th>
  <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Updated At</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Actions</th>
  </tr>
</thead>

        <tbody>
          {filteredData?.map((user, index) => (
            <tr key={index}>
  

              <td>{(page - 1) * Limit + index + 1}</td>
              <td>
  <Link 
    to={user?.excelURL} 
    target="_blank" // Open in a new tab
    rel="noopener noreferrer" // Security measure for opening in a new tab
  >
    {user?.filename}
  </Link>
</td>
{Role ==="false" && (
<td>{user?.corporate_name}</td>
)}

<td title="Users">
 
    {user?.total_users}
 
</td>
<td>
  <Link
    to={`/view-excel-users-logs/${user?._id}`}
    state={{ UserViewData: user, ImportedID: user?._id, Status: "success" }}
    title="Users"
    style={{ color: "green", fontWeight: "bold" }} // Green color for success
  >
    {user?.addedUsers}
  </Link>
</td>

<td>
  <Link
    to={`/view-excel-users-logs/${user?._id}`}
    state={{ UserViewData: user, ImportedID: user?._id, Status: "failure" }}
    title="Users"
    style={{ color: "red", fontWeight: "bold" }} // Red color for failure
  >
    {user?.failureUsers}
  </Link>
</td>

<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
  <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center", 
      color: "" ,   // Centers content vertically
      backgroundColor: 
        user?.status === 'Pending' ? 'yellow' :
        user?.status === 'Processing' ? 'orange' :
        user?.status === 'Completed' ? 'green' : 'purple',  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button></td>
           <td>{user?.uploaded_by}</td>
             <td>{user?.createdAt}</td>
          
          <td style={{ whiteSpace: 'nowrap' }}>
        
                &nbsp;&nbsp;&nbsp;
                <Link to={`/usermanagement/users/${user?._id}`} state={{ UserViewData: user, ImportedID : user?._id }} title="Users">
                <LuUser2/>

                </Link>
                &nbsp;&nbsp;
              
              
              </td>
            </tr>
          ))}
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>


 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default ImportExcel;
